/* global $ */

class DesignApproachSection {
    constructor($container) {
        this.$window = $(window);
        this.$container = $container;
        this.$content = this.$container.find('.Stack--md-lg');
        this.$imgLeft = this.$container.find('.Column--stickOut-left');
        this.$imgRight = this.$container.find('.Column--stickOut-right');
        this.$switcher = this.$container.find('.Switcher-lg-column');
        this.$btnPrev = this.$container.find('.CircleButton--prev');
        this.$btnNext = this.$container.find('.CircleButton--next');

        this.mediaQuery = window.matchMedia('(min-width: 1024px)');
        this.position = 'center';
        this.$container.attr('data-position', this.position);

        this.$btnPrev.on('click', () => {
            this.prev();
        });
        this.$btnNext.on('click', () => {
            this.next();
        });

        this.$window
            .on('resize', () => {
                this.onWindowResize();
            });
        this.onWindowResize();
    }

    prev() {
        if(this.position == 'center') this.position = 'left';
        else if(this.position == 'right') this.position = 'center';
        this.$container.attr('data-position', this.position);
        this.onWindowResize();
    }

    next() {
        if(this.position == 'center') this.position = 'right';
        else if(this.position == 'left') this.position = 'center';
        this.$container.attr('data-position', this.position);
        this.onWindowResize();
    }


    onWindowResize() {
        if (this.mediaQuery.matches) {
            let tmpHeight = this.$imgLeft.children('.Image').height();
            if(tmpHeight < this.$imgRight.children('.Image').height()) tmpHeight = this.$imgRight.children('.Image').height();

            if(this.$content.height() < tmpHeight) {
                this.$content.parent().css('height', `${tmpHeight}px`);
            } else {
                this.$content.parent().css('height', `auto`);
            }

            if(this.position == 'center') {
                this.$switcher.css('transform', `translateX(0)`);
            } else if(this.position == 'left') {
                this.$switcher.css('transform', `translateX(${-(this.$imgLeft.position()['left'] - this.$content.width() / 2 + this.$imgLeft.width() / 2)}px)`);
            } else if(this.position == 'right') {
                this.$switcher.css('transform', `translateX(-${this.$imgRight.position()['left'] + this.$imgRight.width() / 2 - this.$content.width() / 2}px)`);
            }
        } else {
            this.$content.parent().css('height', `auto`);
            this.$switcher.css('transform', `translateX(0)`);
        }
    }
}

export default DesignApproachSection;